<ppl-referral-logic [selectedState]="state"></ppl-referral-logic>